import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  ngOnInit() {
    const topOfPage = document.querySelector('app-website-header');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    this.checkAllBreakPoints();
  }
  constructor(private breakpointObserver: BreakpointObserver) { }
  checkAllBreakPoints() {
    this.breakpointObserver.observe([
      '(max-width: 767.98px)'
    ]).subscribe(r => {
      if(r.matches) {
        if(r.breakpoints['(max-width: 767.98px)']) {
          this.resetScrollSettings();
        }
      }
    })
  }

  resetScrollSettings(): void {
    setTimeout(() => {
      const body = document.body;
      const html = document.documentElement;

      body.style.overflow = 'auto';
      html.style.overflow = 'auto';
    });
  }

  }

